import { createContext } from 'react';
import { IS_GLOBAL_PREFERENCE_ENABLED } from '../../GlobalPreferences/constants.js';
const DEFAULT_GLOBAL_NAV_CONTEXT = {
  themeMode: 'default',
  signInUrl: '',
  signUpUrl: '',
  onClickSignIn: undefined,
  onClickSignUp: undefined,
  productName: '',
  productUrl: '',
  onClickProductName: undefined,
  isJapan: false,
  isIndia: false,
  useNewLogo: false,
  showSignInButton: true,
  showSignUpButton: true,
  showGetStartedButtonOnMobile: true,
  showCoinbaseBytes: false,
  localeCode: '',
  localeFromUrl: '',
  isGlobalPreferencesEnabled: IS_GLOBAL_PREFERENCE_ENABLED,
  secondaryProductUrl: '',
  secondaryProductName: '',
  detachBannerFromNav: false
};
const GlobalNavContext = /*#__PURE__*/createContext(DEFAULT_GLOBAL_NAV_CONTEXT);
export { DEFAULT_GLOBAL_NAV_CONTEXT, GlobalNavContext as default };
//# sourceMappingURL=GlobalNavContext.js.map
